export const DRAW_CONSTS = {
  HEIGHT: 400,
  LABEL_HEIGHT: 20,
  LABEL_MIN_GAP: 5,
  LABEL_MARGIN: 2,

  COUNTRY_WIDTH: 12,
  GAP: 3,
  GLOBAL_WIDTH: 80,
  RECT_SEPARATOR_HEIGHT: 1,

  MAX_OPACITY: 0.15,
  GRADIENT_START_PERC: 0.4,

  HOVERED_OPACITY: 0.4,
} as const
